import React, {useState, useEffect, useMemo, useLayoutEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
import './App.css';
import './ret.css';
import 'boxicons';
import {hi, ho, he} from './store';
import Recommen from './recommen';
import { facebook, kakao} from './image';
import axios from 'axios';
import dayjs from 'dayjs';
import { isMobile } from 'react-device-detect';
import Modal from 'react-modal';
Modal.setAppElement('#root');

const Nodal = ({is, isOpen, onClose, onConfirm, message }) => {

    useEffect(()=>{
        if(isOpen){
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollbarWidth}px`;
        }else{
            document.body.style.overflow = 'unset';
            document.body.style.paddingRight = '0px';
        };
    
        return () => {
          document.body.style.overflow = 'unset';
          document.body.style.paddingRight = '0px';
        };
      }, [isOpen]);

    if (!isOpen) return null;
  
    return (
      <div className="nodal-overlay" onClick={onClose}>
        <div className="nodal-content" onClick={(e) => e.stopPropagation()}>
          <h3>돌파공모</h3>
          <p>{message}</p>
          <div className="nodal-buttons">
            <button className="cbtn" onClick={onClose}>확인</button>
            {is == true && <button className="dbtn" onClick={onConfirm}>로그인</button>}
          </div>
        </div>
      </div>
    );
  };


const Show=()=>{
    
    const konst = useParams();
    const locaa = useLocation();
     const ngate = useNavigate();
     const neyong = useLocation();
    const [first, setfirst] = useState(1);
    const [ussa, setussa] = useState(0);
    const [gurim, setgurim] = useState(locaa.state == null ? {"hit" : 0, "title" : "oo", "targets" : 0} : {...locaa.state, b: []});
    const [spin, setspin] = useState(false);
    const [sonza, setsonza] = useState("");
    const [chayo, setchayo] = useState(false);
    const furi = useSelector(state=>state.midori);
    const fale = useSelector(state=>state.mahena);
    const goruki = ["아이디어", "글쓰기", "네이밍", "과학", "콘텐츠", "논문", "대외활동","교육"];
    const jikao = ["ya1", "ya2", "ya3", "ya4", "ya5", "ya6", "ya7", "ya8"];

    const dispatch = useDispatch();
    const customStyles = {
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
        },
      };

    const fal = async()=>{
        if(fale?.id){
            
            const zhi = gurim.b.filter((vl)=>vl == fale.id);
         
            if(zhi.length == 0){
            const zipa=JSON.parse(gurim?.categol);
          
            const hipa=goruki.indexOf(zipa[0]);
            //const pipa=zipa.split(',');
            const sipa=gurim?.categol.split(',');
            const mimal = jikao[hipa];    
            const hitzun=fale[`${mimal}`];
         
            const htz = JSON.parse(hitzun);
            const htzed = {...htz, 타깃 : htz.타깃+1};    
            
             const parb=await gurim.b.push(fale.id);
           
            const kitt = await axios.get(`/api/heart/${konst.wow}?ends=${dayjs(gurim?.end).format("YY-MM-DD")}&title=${gurim?.title}&categ=${mimal}&par=${JSON.stringify(gurim.b)}&ta=${parb}&htz=${JSON.stringify(htzed)}`).then(bb=>{
                
                const kina = {...fale, [mimal] : JSON.stringify(htzed)}; 
                dispatch(he(kina));
                // alert("배움의 도전을 만끽하세요!! 수상까지 응원합니다");
                setsonza("배움의 도전을 만끽하세요!! 수상까지 응원합니다");
                setspin(true);
                setussa(gurim.targets+1);
                }).catch(err=>{
                    if(err.response?.data?.success === "hneed"){
                        setsonza("처리과정에서 오류가 발생했습니다");
                    };
                });
            }else{
                // alert("이미 타겟팅 완료했어요!!");
                setsonza("이미 타겟팅 완료했어요!!");
                setspin(true);
            };    
        }else{
            // alert("login이 필요해요!");
            setsonza("login이 필요해요!");
            setchayo(true);
            setspin(true);
        };
    };

  const [pic, setpic] = useState(false);
  useMemo(() => {
    if(pic == true){
        document.body.style.overflowY="hidden";
    }else{
        document.body.style.overflowY="auto";
    };
    
   
}, [pic]);


const igreg = () => {
   
    document.body.style.overflowY = "auto";
    window.history.states = window.history.tates;
    
    setpic(false);
    };

useLayoutEffect(()=>{
    setgurim({...locaa.state, b: []});
        const gefux = async ()=>{
            window.scrollTo(0,0);
            const coke = await axios.get(`/api/datonce/${konst.wow}`).then(aa=>{
               
                setgurim({...aa.data.a, b: JSON.parse(aa.data.a.partee)});
                
               
            }).catch(err=>console.log("uhaaaa~~"));};
            
        const refux = async ()=>{
            const koke = await axios.get(`/api/datone/${konst.wow}`).then(aa=>{setgurim({...locaa.state, b: JSON.parse(aa.data.b)});
        }).catch(er=>console.log("yucky!"));
        };    
    
            if(locaa.state == null){
            gefux();
            }else{
                window.scrollTo(0,0);
              
                refux();
            };
    },[konst.wow]);


useLayoutEffect(()=>{
   
    window.addEventListener('popstate', igreg);
    return ()=>{
        document.body.style.overflowY = "auto";
        window.history.states = window.history.tates;
        window.removeEventListener('popstate', igreg);};
},[]);


useEffect(()=>{
   
  
    const choi = dayjs(gurim?.start).startOf('day').diff(dayjs().startOf('day'), 'day');
    const dais = dayjs(gurim?.end).startOf('day').diff(dayjs().startOf('day'), 'day');
    
       document.getElementById("00").innerHTML= gurim?.story;
       document.getElementById("kosu").innerHTML= gurim?.tips == undefined ? '' : gurim.tips;
        document.title = gurim.title + " - 돌파공모";
    if(choi>0){setfirst({de : "soon", st : "진행예정"});}else if(dais >= 0 && dais <= 7){
        setfirst({de : "finale", st : "곧마감"});}else if(dais > 7){
            setfirst({de : "nowing", st :"접수중"});}else if(dais < 0){setfirst({de : "kkuk", st : "마감"});};
}, [gurim.title]);

const tips=()=>{
    document.getElementById("kosu").innerHTML= gurim?.tips == undefined ? '' : gurim.tips;
    document.getElementById("left").style.backgroundColor="#f4fbf9";
    document.getElementById("right").style.backgroundColor="white";
};

const chamgo=()=>{
    document.getElementById("kosu").innerHTML= gurim?.chamtext == undefined ? '' : gurim.chamtext;
    document.getElementById("right").style.backgroundColor="#f4fbf9";
    document.getElementById("left").style.backgroundColor="white";
};

const boksa=()=>{
    const bboo = window.location.href;
    navigator.clipboard.writeText(bboo).then(()=>{alert("클립보드에 복사했어요!");}).catch(err=>{console.log("다시복사해봐요");});
};

const facesh=()=>{
    const bbaa = window.location.href;
    window.open(`http://www.facebook.com/sharer/sharer.php?u=${bbaa}`);
}

const closedal = ()=>{
    setspin(false);
    setsonza("");
    setchayo(false);
};

const ridal=()=>{
    const scol = window.scrollY;
    const rath = encodeURIComponent(neyong.pathname + neyong.search);
   
    ngate(`/join?coin=${rath}&scol=${scol}`);
};

return(
<div className={isMobile ? 'manugi' : 'nanugi'}>
              
<div className='namoji2'>
    {isMobile ? <div className='mhits'>
        <div>
            <p style={{marginBottom:"8px", fontSize:"18px",fontWeight:"500"}}>{gurim.title}</p>
        </div>
        <div className='mbohit'>
            <span className={first?.de}>{first?.st}</span>
            <span className='mmhit'>Hit : {locaa.state == null ? gurim.hit : gurim.hit+1}</span>
        </div>
    </div> :
    <div className='hits'>
        <span>{gurim.title}</span>
        <span className={first?.de}>{first?.st}</span>
        <span>Hit : {locaa.state == null ? gurim.hit : gurim.hit+1}</span>
    </div>
    }
    <div className={isMobile ? 'meyong' : 'neyong'}>
        <div>
            {isMobile ? <div className={pic ? 'md' : 'mkda'} onClick={()=>setpic(!pic)}>
            <img className={pic ? 'ssmd' : 'skda'} src={process.env.PUBLIC_URL+'/upost/'+gurim?.poster} />
            </div> :
            <div className={pic ? 'md' : 'kda'} onClick={()=>setpic(!pic)}>
            <img className={pic ? 'smd' : 'skda'} src={process.env.PUBLIC_URL+'/upost/'+gurim?.poster} />
            </div>
            }
        </div>

        <div>
            <table style={{borderTop:"1px solid #1323186e"}}>
                <tbody>
                {gurim?.designer && <tr><th>주최사</th><td>{gurim?.designer}</td></tr>}
                {gurim?.holder && <tr><th>주관사</th><td>{gurim?.holder}</td></tr>}
                <tr><th>시작일</th><td>{dayjs(gurim?.start).format("YYYY-MM-DD")}</td></tr>
                <tr><th>마감일</th><td>{dayjs(gurim?.end).format("YYYY-MM-DD")}</td></tr>
                <tr><th>분류</th><td>{gurim?.categol && JSON.parse(gurim?.categol).join(', ')}</td></tr>
                {/* <tr><th>문의처</th><td style={{lineBreak : "anywhere"}}>{gurim?.tels}</td></tr> */}
                {gurim?.homepage && <tr><th>홈페이지</th><td><a href={gurim?.homepage} className='sosa' target='_blank'>바로가기</a></td></tr>}
                <tr>
                    <th>관련자료</th>
                    <td>{gurim?.info && JSON.parse(gurim.info).map((a,i)=>{return(
                     <a key={i} href={process.env.PUBLIC_URL+'/uptext/'+a} download={a.replace(/^\d+_/ , "")} className='downgap'><button><img src={process.env.PUBLIC_URL+'/download.png'} className='down2'/><span>첨부파일</span></button></a>
                    );})}
                    </td>
                </tr>
                </tbody>
            </table>
            <div className='flo'>
                <span onClick={boksa}><img src={process.env.PUBLIC_URL+"/copy.png"} className='hott' /></span>
                <span><img src={kakao} /></span>
                <span onClick={facesh}><img src={facebook} /></span>
                <span onClick={fal}><img src={process.env.PUBLIC_URL+'/hot.png'} className='hott'/></span>
                <span style={{verticalAlign : "top", width : "35px", backgroundImage: `url(${process.env.PUBLIC_URL}/splaz.png)`}} className='sshots'>{ussa == 0 ? gurim?.targets : ussa}</span>
            </div>
            <div className='fik'>
                <span onClick={tips} id="left" style={{backgroundColor : "#f4fbf9"}}>Tips</span>
                <span onClick={chamgo} id="right">참고자료</span>
                <div id="kosu" className={isMobile ? 'kkoss mkkoss' : 'kkoss'}>
                </div>
            </div>
        </div>
        <div className={isMobile ? "fla smos" : "fla lmos"}>
            <h3>공모요령</h3>
            <div className='flan'>
                <div className={isMobile ? "mflan2" : "flan2"}><p></p></div>
                <div id='00' style={{textAlign : "left"}} className={isMobile ? "metable" : "retable"}></div>
                <div className={isMobile ? "mflan2" : "flan2"}><p></p></div>
            </div>
        </div>
    </div>
    <div className='jamia'>
       <Link to={window.history.tates?.pasc ? window.history.tates?.pasc : "/"} preventScrollReset={true}><button onClick={()=>{window.history.states = window.history.tates;}} className='jemio'>목록</button></Link>
    </div>  
</div>
{gurim?.categol && <Recommen imf={gurim?.categol} wesh={konst.wow}/>}
 {/* <Modal isOpen={spin} style={customStyles} onRequestClose={closedal}>
    <div style={{ textAlign: 'center' }}>
    <p>{sonza}</p>
    <button onClick={closedal}>확인</button>
    </div>
    </Modal> */}
    <Nodal is={chayo} isOpen={spin} message={sonza} onClose={closedal} onConfirm={ridal}/>
</div>
);
};
export default Show;
